import { decrypt } from '../../util/Security';
import { postStatusMsg } from '../api/StatusApi';
import { fetchCandidateDetails } from './CandidateAction';
export const sendStatusMsg = (msgDetails) => async (dispatch) => {
    const response = await postStatusMsg(msgDetails);
    if (response?.data) {
        let loggedIn = localStorage.getItem('login');
        if (loggedIn) {
            let data = decrypt(loggedIn);
            dispatch(fetchCandidateDetails(data?.candidateId));
        }
    } else if (response?.error) {
        let notify = { msg: response.error, theme: 'error' };
        dispatch({ type: 'NOTIFICATION', payload: notify });
    }
};
